export function trimMoneyDecimals(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "";
  const str = typeof value === "number" ? String(value) : value.trim();
  if (str === "") return "";
  const [integerPart] = str.split(/[.,]/);
  return integerPart;
}
